export default "__VITE_ASSET__BRpdt_HB__"